import { cn } from "@newxsystems/shared";
import type { BlockSpacing } from "@newxsystems/types";
import type { IBlockContainerProps } from "./BlockContainer.props";

const spacingClasses: Record<BlockSpacing, string> = {
  tight: "py-10 md:py-14",
  normal: "py-14 md:py-20",
  loose: "py-20 md:py-28",
};

const containedClasses = "container md:px-8 lg:px-12";

export const BlockContainer = ({
  anchorId,
  as: Element = "section",
  children,
  disableSpacing = false,
  fullWidth = false,
  innerClassName,
  parentClass,
  spacing,
}: IBlockContainerProps) => {
  const spacingClass = disableSpacing ? undefined : spacingClasses[spacing ?? "normal"];

  if (fullWidth) {
    return (
      <Element className={cn("w-full", spacingClass, parentClass)} id={anchorId ?? undefined}>
        <div className={cn(containedClasses, innerClassName)}>{children}</div>
      </Element>
    );
  }

  return (
    <Element className={cn(containedClasses, spacingClass, parentClass)} id={anchorId ?? undefined}>
      {children}
    </Element>
  );
};

BlockContainer.displayName = "Shared::BlockContainer";
